export default "__VITE_ASSET__EB6Fjjmo__"